import { Link, ResourceList } from '../models/Navigation'

/**
 * Removes a / from the end of a string that ends with a forward slash
 * @param url the URL may or may not end with a forward slash
 * @returns a string without a forward slash at the end
 */
const removeTrailingSlash = (url: string) => {
  if (url.slice(-1) === '/') {
    return url.slice(0, -1)
  }

  return url
}

/**
 * Gets the host and the pathname from a URL
 * @param urlString the URL to get the relevant parts from
 * @returns string
 */
const getRelevantPartOfURLString = (urlString: string) => {
  const url = new URL(urlString)
  // TODO: Add host based on MEDICARE_ENV so this will still work in local environments, or just leave out host
  // const partialURL = url.host + url.pathname
  const partialURL = url.pathname

  return removeTrailingSlash(partialURL)
}

/**
 * Checks to see if any of the links within a group of resource lists has
 * a URL that matches the URL of the current page
 * @param resourceLists An array of lists that contain links with hrefs
 * @returns boolean
 */
export const checkSubsectionForActiveLinks = (resourceLists: Array<ResourceList>): boolean => {
  const pathsToIgnore = ['/account/login']
  // We don't care about any other part of the URL whenever we
  // try to match the URL of a link to the URL of the current page.
  const currentPath = removeTrailingSlash(window.location.pathname)

  if (pathsToIgnore.includes(currentPath)) {
    return false
  }

  // TODO: Remove if we really don't need these vaiarbles
  // const currentHost = window.location.host
  // const currentURL: string = currentHost + currentPath

  const urls: Array<string> = resourceLists.flatMap((resourceList: ResourceList) => {
    return resourceList.links.map((link: Link) => getRelevantPartOfURLString(link.href))
  })

  const hasActiveLink: boolean = urls.some(url => {
    // return url === currentURL
    return url === currentPath
  })

  return hasActiveLink
}
